import { comercios } from '@/utils/data.js'

// state
const state = {
  comercios
}

// getters
const getters = {
  getComercios () {
    return state.comercios
  }
}

// actions
const actions = {}

// mutations
const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}
